const _excluded = ["className", "children", "styleType"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { useDeprecate, variantSwitch } from '@adsk/alloy-react-helpers';
import theme from '@adsk/alloy-react-theme';
import Button from './Button';
import BasicButton from './templates/BasicButton';
import LinkButton from './templates/LinkButton';
const StyleType = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  DANGER: 'danger',
  CANCEL: 'cancel',
  LINK: 'link',
  LINK_SECONDARY: 'link-secondary',
  ICON: 'icon',
  ICON_MINIMAL: 'icon-minimal',
  NAVIGATION: 'navigation',
  INLINE_LINK: 'inline-link'
};
function getVariant(styleType) {
  switch (styleType) {
    case StyleType.PRIMARY:
    case StyleType.DANGER:
      return Button.VARIANTS.PRIMARY;
    case StyleType.DEFAULT:
      return Button.VARIANTS.SECONDARY;
    case StyleType.CANCEL:
      return Button.VARIANTS.TERTIARY;
    default:
      return undefined;
  }
}
const ButtonAdapter = _ref => {
  let {
      className,
      children,
      styleType
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  useDeprecate(true, '@adsk/alloy-react-button', 'ButtonAdapter', 'Button');
  let ButtonComponent = Button;
  if (styleType === StyleType.ICON || styleType === StyleType.ICON_MINIMAL || styleType === StyleType.NAVIGATION) {
    ButtonComponent = BasicButton;
  }
  if (styleType === StyleType.LINK || styleType === StyleType.LINK_SECONDARY || styleType === StyleType.INLINE_LINK) {
    ButtonComponent = LinkButton;
  }
  return /*#__PURE__*/React.createElement(ButtonComponent, _extends({
    className: className,
    variant: getVariant(styleType),
    alert: styleType === StyleType.DANGER,
    style: variantSwitch({
      statement: styleType,
      variants: {
        [StyleType.LINK_SECONDARY]: {
          color: theme.colors.charcoal600
        },
        [StyleType.NAVIGATION]: {
          color: theme.colors.black
        },
        [StyleType.INLINE_LINK]: {
          padding: 0
        },
        [StyleType.ICON_MINIMAL]: {
          padding: 0
        }
      }
    })
  }, props), children);
};
ButtonAdapter.StyleType = StyleType;
ButtonAdapter.getVariant = getVariant;
ButtonAdapter.propTypes = {
  /** custom className for the button */
  className: PropTypes.string,
  /** component's children */
  children: PropTypes.any,
  /** HTML type attribute of the button, default to 'button' */
  type: PropTypes.string,
  /** style for the button. Can be one of Button.StyleType */
  styleType: PropTypes.oneOf(Object.values(ButtonAdapter.StyleType))
};
export default ButtonAdapter;
//# sourceMappingURL=ButtonAdapter.js.map